/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from '@mui/material';
import { useCallback, useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { ClientKind } from '../../api/enumerations';
import { getAllInspectionForms } from '../../api/forms';
import { InspectionFormData } from '../../api/forms/types';
import logoBb from '../../assets/images/logo-bb.svg';
import logoCaixa from '../../assets/images/logo-caixa.svg';
import Snackbar from '../../components/Snackbar';
import { TitleBox } from '../../components/UI/Box';
import { GridMain } from '../../components/UI/Grid';
import { TitleTypography } from '../../components/UI/Typography';
import { Constants } from '../../constants/forms';
import {
  IconAddMS,
  IconBookmarkMS,
  IconCheclistRtlMS,
  IconListAltMS,
} from '../../constants/icons';
import { GlobalContext } from '../../context/global';
import { checkCardColor, convertDate } from '../../helpers';
import useErrorMessage from '../../hooks/useErrorMessage';
import {
  BankFlag,
  CardContainer,
  CardLabel,
  CardSubtitle,
  FlexCenterBox,
  FormButton,
  SectionTitle,
  SectionTitleContainer,
  TypeFlag,
} from './styles';

export function Forms(): JSX.Element {
  const [formsData, setFormsData] = useState<InspectionFormData[]>([]);
  const [templateFormsData, setTemplateFormsData] = useState<
    InspectionFormData[]
  >([]);

  const { openSnackbar, setErrorMessage, setOpenSnackbar, setSnackbarMessage } =
    useContext(GlobalContext);

  const { getErrorMessage } = useErrorMessage();
  const navigate = useNavigate();

  const getDataCallback = useCallback(async () => {
    try {
      const response = await getAllInspectionForms(true);

      if (response.detail.description) {
        throw new Error(response.detail.description);
      }

      if (!response.data) {
        throw new Error('Algo deu errado, tente novamente.');
      }

      setTemplateFormsData(response.data);
    } catch (error) {
      setSnackbarMessage(getErrorMessage(error));
      setErrorMessage(true);
      setOpenSnackbar(true);
    }

    try {
      const response = await getAllInspectionForms(false);

      if (response.detail.description) {
        throw new Error(response.detail.description);
      }

      if (!response.data) {
        throw new Error('Algo deu errado, tente novamente.');
      }

      setFormsData(response.data);
    } catch (error) {
      setSnackbarMessage(getErrorMessage(error));
      setErrorMessage(true);
      setOpenSnackbar(true);
    }
  }, []);

  useEffect(() => {
    getDataCallback();
  }, [getDataCallback]);

  return (
    <GridMain>
      <TitleBox>
        <TitleTypography>
          {IconListAltMS}
          {Constants.forms}
        </TitleTypography>
      </TitleBox>
      <FlexCenterBox>
        <FormButton onClick={() => navigate('/forms/new')}>
          {IconAddMS}
          {Constants.newForm}
        </FormButton>
      </FlexCenterBox>
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <SectionTitleContainer>
            <SectionTitle>
              {IconBookmarkMS}
              {Constants.templates}
            </SectionTitle>
          </SectionTitleContainer>
        </Grid>
        {templateFormsData.map((data) => (
          <Grid item xs={4} key={data.id}>
            <Link
              to={`/forms/${data?.id}/edit`}
              style={{ textDecoration: 'none' }}
              key={data.id}
            >
              <CardContainer>
                <TypeFlag
                  sx={{
                    backgroundColor: checkCardColor(data.client_kind),
                  }}
                />
                {data.client_kind === ClientKind.BRASIL_BANK && (
                  <BankFlag image={logoBb} title="logo banco do brasil" />
                )}
                {data.client_kind === ClientKind.CAIXA && (
                  <BankFlag image={logoCaixa} title="logo caixa" />
                )}
                <CardLabel>
                  {IconCheclistRtlMS}
                  {data.title}
                </CardLabel>
              </CardContainer>
            </Link>
            <CardSubtitle>
              {Constants.lastModified} {convertDate(data.updated_at)}
            </CardSubtitle>
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <SectionTitleContainer>
            <SectionTitle>
              {IconBookmarkMS}
              {Constants.saved}
            </SectionTitle>
          </SectionTitleContainer>
        </Grid>
        {formsData.map((data) => (
          <Grid item xs={4} key={data.id}>
            <Link
              to={`/forms/${data?.id}/edit`}
              style={{ textDecoration: 'none' }}
              key={data.id}
            >
              <CardContainer>
                <TypeFlag
                  sx={{
                    backgroundColor: checkCardColor(data.client_kind),
                  }}
                />
                {data.client_kind === ClientKind.BRASIL_BANK && (
                  <BankFlag image={logoBb} title="logo banco do brasil" />
                )}
                {data.client_kind === ClientKind.CAIXA && (
                  <BankFlag image={logoCaixa} title="logo caixa" />
                )}
                <CardLabel>
                  {IconCheclistRtlMS}
                  {data.title}
                </CardLabel>
              </CardContainer>
            </Link>
            <CardSubtitle>
              {Constants.lastModified} {convertDate(data.updated_at)}
            </CardSubtitle>
          </Grid>
        ))}
      </Grid>
      {openSnackbar && <Snackbar />}
    </GridMain>
  );
}
